<template>
  <div
    id="floatWindow"
    ref="floatWindow"
    v-show="floatWindowShow"
    @mouseover="clearFdAd"
    @mouseout="starFdAd"
  >
<div class="con">

    <div
      class="close"
      @click="floatWindowShow = false"
    >
        <img src="@/assets/image/cha.png" />
    </div>
    <div class="win-con" 
      @click="openUrl">
        <img v-if="content.floatPicture" :src="content.floatPicture" />
        <p  v-if="content.floatText">{{ content.floatText }}</p>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'DragBall',
  props: {
    content: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      //定义相关参数
      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 3,
      delay: 20,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      floatWindowShow: true,
      interval: null,
    }
  },

  mounted() {
    console.log(this.content)
    this.starFdAd()
  },
  methods: {
    changePos() {
      let width = document.documentElement.clientWidth
      let height = document.documentElement.clientHeight
      if (this.$refs.floatWindow) {
        this.Hoffset = this.$refs.floatWindow.offsetHeight //获取元素高度
        this.Woffset = this.$refs.floatWindow.offsetWidth
        // 滚动部分不随屏幕滚动
        this.$refs.floatWindow.style.left =
          this.xPos + document.body.scrollLeft + 'px'
        this.$refs.floatWindow.style.top =
          this.yPos + document.body.scrollTop + 'px'

        if (this.yon) {
          this.yPos = this.yPos + this.step
        } else {
          this.yPos = this.yPos - this.step
        }
        if (this.yPos < 0) {
          this.yon = 1
          this.yPos = 0
        }
        if (this.yPos >= height - this.Hoffset) {
          this.yon = 0
          this.yPos = height - this.Hoffset
        }

        if (this.xon) {
          this.xPos = this.xPos + this.step
        } else {
          this.xPos = this.xPos - this.step
        }
        if (this.xPos < 0) {
          this.xon = 1
          this.xPos = 0
        }
        if (this.xPos >= width - this.Woffset) {
          this.xon = 0
          this.xPos = width - this.Woffset
        }
      }
    },
    clearFdAd() {
      clearInterval(this.interval)
    },
    starFdAd() {
      this.interval = setInterval(this.changePos, this.delay)
    },
    openUrl(){
      if(this.content.floatUrl){
      window.open(this.content.floatUrl,'_blank')
      }
    }
  },
}
</script>
<style lang="scss" scoped>
#floatWindow {
  z-index: 9999;
  position: absolute;
  top: 0px;
  left: 0px;
 border-radius: 8px;
 overflow: hidden;
  cursor: pointer;

  .con{
    padding: 16px 15px 16px;
    background: RGBA(234, 211, 175, 1);
    .close{
      display: flex;
      flex-direction: row-reverse;
      position: absolute;
      right: 6px;
      top:6px;
    }
  }

  .win-con {
    width: 140px;
    img{
      max-width: 140px;
      height: 180px;
     border-radius: 10px;
    }
    p{
      margin: 0px;
      // height: 22px;
      font-size: 16px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #222222;
      line-height: 22px;
    }
  }
}
</style>
